import React, { useState } from "react";

import "./languageSwitch.css";
import egyptFlag from "../../../assets/telawah-assets/egyptFlag.png";
import britishFlag from "../../../assets/telawah-assets/britsh.png";
import { useLanguage } from "../../../context/LanguageContext";
const LanguageSwitch = ({ className }) => {
    const { language, switchLanguage } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleLanguageChange = (lang) => {
        switchLanguage(lang);
        setIsOpen(false);
    };

    return (
        <div className={className}>
            <div className="en language-switch px-4 ">
                <div
                    className="selected-language"
                    onClick={toggleDropdown}
                    onMouseEnter={() => setIsOpen(true)}
                >
                    <img
                        src={language === "en" ? britishFlag : egyptFlag}
                        alt={language === "en" ? "English" : "Arabic"}
                        className="flag-icon"
                    />
                    <span>{language === "en" ? "English" : "العربية"}</span>
                </div>
                {isOpen && (
                    <div className="language-dropdown" onMouseEnter={() => setIsOpen(true)}>
                        <div className="language-option" onClick={() => handleLanguageChange("en")}>
                            <img src={britishFlag} alt="English" className="flag-icon" />
                            English
                        </div>
                        <div className="language-option" onClick={() => handleLanguageChange("ar")}>
                            <img src={egyptFlag} alt="العربية" className="flag-icon" />
                            العربية
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LanguageSwitch;
